import { ApiResponse } from "../interfaces/ApiResponse"

async function SuccessHandler(response: ApiResponse<any>): Promise<any> {
  return response || null
}

export default SuccessHandler
